// extracted by mini-css-extract-plugin
export default {"wrap":"Cards_wrap__vViMC","title":"Cards_title__z8e8p","cards":"Cards_cards__yNUl8","card":"Cards_card__etf9a","icon":"Cards_icon__-+lG+","text":"Cards_text__2rK+D"};